var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCropFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 96 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 936q-24 0-42-18t-18-42V704h60v172h172v60H180Zm428 0v-60h172V704h60v172q0 24-18 42t-42 18H608ZM120 448V276q0-24 18-42t42-18h172v60H180v172h-60Zm660 0V276H608v-60h172q24 0 42 18t18 42v172h-60Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCropFree);
export default __webpack_public_path__ + "static/media/crop_free.cfffa132526b15596ae3532a17915db5.svg";
export { ForwardRef as ReactComponent };